import React from 'react';

import { Avatar } from '@mui/material';

import { IUser } from '../../types/user.type';

interface IProps {
  user: IUser;
  size?: number;
}

const UserAvatar = React.memo(({ user, size = 40 }: IProps) => {
  const fullName = React.useMemo(() => {
    if (!user) {
      return '';
    }

    return `${user.firstname} ${user.lastname}`;
  }, [user]);

  const initials = React.useMemo(() => {
    if (!user || !user.firstname || !user.lastname) {
      return 'UU';
    }

    return `${user.firstname.charAt(0).toUpperCase()}${user.lastname.charAt(0).toUpperCase()}`;
  }, [user]);

  return (
    <Avatar
      alt={fullName}
      sx={{
        bgcolor: 'primary.main',
        fontSize: `${size / 2}px`,
        lineHeight: `${size}px`,
        width: size,
        height: size,
      }}
    >
      {initials}
    </Avatar>
  );
});

export default UserAvatar;
